import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function CopyIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props} viewBox="0 0 18 18">
      <path
        fill="currentColor"
        d="M14.893 0H6.707A3.11 3.11 0 0 0 3.6 3.107V3.6h-.493A3.11 3.11 0 0 0 0 6.707v8.186A3.11 3.11 0 0 0 3.107 18h8.186a3.1 3.1 0 0 0 3.066-2.7h.534A3.11 3.11 0 0 0 18 12.193V3.107A3.11 3.11 0 0 0 14.893 0M16.2 12.193c0 .72-.586 1.307-1.307 1.307H14.4V6.707A3.11 3.11 0 0 0 11.293 3.6H5.4v-.493c0-.72.586-1.307 1.307-1.307h8.186c.72 0 1.307.586 1.307 1.307z"
      />
    </BaseIcon>
  );
}
